import Folder from '../store/schema/Folder';
import { getOwaMiniStrings } from 'owa-strings/owa-mini-strings';
import { isFolderDistinguishedFolder } from './isFolderDistinguishedFolder';
import type DistinguishedFolderIdName from 'owa-service/lib/contract/DistinguishedFolderIdName';

const DISTINGUISHED_FOLDER_ID_TO_LOCALIZED_NAMES_MAP: Partial<
    Record<DistinguishedFolderIdName, string>
> = {
    inbox: 'inboxFolderName',
    drafts: 'draftsFolderName',
    sentitems: 'sentItemsFolderName',
    deleteditems: 'deletedItemsFolderName',
    archive: 'archivedEmailsFolderName',
    conversationhistory: 'conversationHistoryFolderName',
    junkemail: 'junkEmailFolderName',
    notes: 'notesFolderName',
    outbox: 'outboxFolderName',
    tasks: 'tasksFolderName',
};

/**
 * Returns the display name for a given folder.
 * Returns the localized names for distinguished folders and DisplayName for user
 * created folders
 * @param folder
 */
export const getFolderDisplayName = (folder: Folder, defaultValue = ''): string => {
    if (!folder) {
        return defaultValue;
    }

    const isDistinguishedFolder = isFolderDistinguishedFolder(folder);

    if (isDistinguishedFolder) {
        const localizedFolderNameId =
            DISTINGUISHED_FOLDER_ID_TO_LOCALIZED_NAMES_MAP[folder.DistinguishedFolderId];

        if (localizedFolderNameId) {
            const strings = getOwaMiniStrings();
            return strings[localizedFolderNameId] || folder.DisplayName;
        }
    }

    // return server returned display name
    return folder.DisplayName;
};
